import React, { useState, useContext, useEffect, Suspense } from 'react';
import { TransitionContext } from '../Context/TransitionContext';

import SignInForm from './SignIn/SignInForm';
import CreateAccount from './CreateAccount/CreateAccount';

import background from "../assets/background.png";

import Navbar from './HomePage/header';

import Footer from './HomePage/footer';
import SupportSection from './HomePage/SupportSection';

import './SingleLanguage.css'
import './About.css';
import Services from './HomePage/services';
import Languages from './HomePage/languages';
import CustomerReviews from './HomePage/CustomerReviews';

const About = ({ windowSize }) => {

  const { setColor, webP } = useContext(TransitionContext);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCreateAccountOpen, setIsCreateAccountOpen] = useState(false);

  const handleLoginOpen = (newState) => {
    setIsModalOpen(newState);
  }

  const handleCreateAccountOpen = (newState) => {
    setIsCreateAccountOpen(newState);
  }

  useEffect(() => {
    setColor(false);
  }, [setColor]);


  return (
    <div className='bg-[#EFF3F5] w-full flex flex-col items-center cursor-default'>
    <SignInForm open={isModalOpen} isLoginFormOpen={handleLoginOpen} isCreateAccountOpen={handleCreateAccountOpen}/>
    <CreateAccount open={isCreateAccountOpen} isCreateAccountOpen={handleCreateAccountOpen} isLoginFormOpen={handleLoginOpen}/>


     {/* banner */}
     <div className='w-full md:p-4 p-2'>

      <div className='w-full bg-[#12ABBF] rounded-4xl max-md:rounded-xl max-md:pb-4'>
          {/* navbar */}
        <div className=' pt-[30px] pb-[27px] mx-4'>
            <Navbar windowSize={windowSize} isLoginFormOpen={handleLoginOpen}/>
        </div>
        <div className='bannerContainer px-2'>
            <h1 className='bannerText text-center'>About eVerbary</h1>
        </div>
        <div className='flex flex-col gap-4 w-full items-center pb-[107px] max-md:pb-[30px] px-2'>
          <p className='text-[#fff] text-base text-center xl:w-[50%] md:w-1/2 w-full'>
          eVerbary helps individuals and businesses with quick and affordable document translation services. Our team of professional translators have a wide range of experience and deep specialization in many areas, such as translating supporting documents for U.S. green card or citizenship applications, academic transcripts for university applications, financial records for mortgages, legal documents for judicial proceedings, and many other user cases.
              <br /><br />
              We are excited to have you as a customer and look forward to working with you. If you have any questions, feel free to contact our support team and we'll get right back to you.
          </p>
        </div>
      </div>

      <Suspense fallback={<div></div>}>
        <Services windowSize={windowSize} />
      </Suspense>

      <Languages showMostPopularDocuments={false} />


      <div
          style={{ backgroundImage: `url(${background})` }}
          className="overflow-hidden rounded-4xl bg-cover bg-center mt-5 space-y-8 "
        >
          <div className="flex flex-col gap-4 items-center md:p-8 p-4 mt-10">
            <h2 className="font-secondary font-medium md:text-5xl text-4xl text-white uppercase text-center ">
                Professional Translators Delivering Dependable Quality
            </h2>
            <p className="text-[#BDC1C9] text-base text-center w-full max-w-[1000px] mx-auto">
            The core of our business is our translation team. Through the years we've assembled an amazing group that share our values. We take a rigorous approach to quality, deadlines, and communication, which allow us to consistently deliver translations that exceed our customer's expectations.
            <br/><br/>
            The combination of this amazing group of translators paired with our proprietary systems and excellent customer support lead to a service that has unmatched value.
            </p>
          </div>
        </div>

      <Suspense fallback={<div></div>}>
        <CustomerReviews mTop="mt-5" />
      </Suspense>
      

      <SupportSection windowSize={windowSize} />

     </div>

    <div className=' w-full pb-10 bg-[#12ABBF]'>
          <Footer windowSize={windowSize} light={true}  />
      </div>  

  </div>
  );
}

export default About;